/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SlovakianInputs */



/**
* | output |
* | --- |
* | "Slovakian" |
*
* @param {Speechmatics_Target_Language_SlovakianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_slovakian = /** @type {((inputs?: Speechmatics_Target_Language_SlovakianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SlovakianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Slovaque")
	if (locale === "de") return /** @type {LocalizedString} */ ("Slowakisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("slovacco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("словацкий")
	if (locale === "es") return /** @type {LocalizedString} */ ("eslovaco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("斯洛伐克语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スロバキア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्लोवाकियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("eslovaco")
	return /** @type {LocalizedString} */ ("Slovakian")
});